// Converts a stored ISO timestamp into the local-time value a `datetime-local`
// input expects ("YYYY-MM-DDTHH:mm"), and back. Round-tripping through the
// browser's local timezone is fine for admin forms — dates are set by eye, not
// to the minute.
export function isoToDatetimeLocal(iso: string | null | undefined): string {
    if (!iso) return '';
    const date = new Date(iso);
    if (isNaN(date.getTime())) return '';
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function datetimeLocalToIso(value: string): string | null {
    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date.toISOString();
}
